'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as Styled from './styles';
const Button = forwardRef(({ isColorInverted = true, children, ...buttonProps }, ref) => {
    return (_jsx(Styled.Button, { ref: ref, variant: isColorInverted ? 'white-on-transparent' : 'black-on-transparent', allCaps: true, borderless: true, size: 'small', ...buttonProps, children: children }));
});
const FlagIconImage = forwardRef((imgProps, ref) => {
    return _jsx(Styled.LocaleButtonFlagIconImage, { ref: ref, ...imgProps });
});
const TextSpan = forwardRef(({ children, ...spanProps }, ref) => {
    return (_jsx(Styled.TextSpan, { ref: ref, ...spanProps, children: children }));
});
export { Button as LocaleButton, TextSpan as LocaleButtonText, FlagIconImage as LocaleButtonIcon };
//# sourceMappingURL=index.js.map